module.exports = __webpack_public_path__ + "media/metronic/_theme/media/blog/blog3-c6a1ce0978fdf3ab99e8b6e4254616e3.jpg";